import React from "react"
import { Box, useMediaQuery, useTheme } from "@material-ui/core"
import useStore from "src/v2/utils/store"
import useASTStore from "src/v2/utils/AST-store"
import OneResource from "src/v2/components/app-components/resource-viewer/one-resource"

function CardContainer({ children, topIsSquare = false }) {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"))
  return (
    <Box
      style={{
        borderRadius: topIsSquare ? 0 : 11,
        background: "#f5f5f5",
        padding: isMobile ? 8 : 16,
        boxShadow: "4px 4px 4px 0px rgba(0, 0, 0, 0.25)",
      }}
    >
      {children}
    </Box>
  )
}

export default function ResourceList() {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"))
  const oneReview = useStore((state) => state.oneReview)
  const selectedResourseType = useASTStore((state) => state.selectedResourseType)
  const elements =
    oneReview?.analyzedData?.json?.tabsObject?.[selectedResourseType]?.elements || []

  return (
    <CardContainer topIsSquare>
      {elements.length === 0 ? (
        <Box p={2} color="textSecondary" textAlign="center">
          No resource available
        </Box>
      ) : (
        <Box display="flex" flexWrap="wrap" alignItems="flex-start">
          {elements.map((x) => (
            <Box
              key={x.astId || x.displayName}
              mb={isMobile ? 0.5 : 1}
              mr={isMobile ? 0.5 : 1}
              style={{ display: "inline-block" }}
            >
              <OneResource resource={x} />
            </Box>
          ))}
        </Box>
      )}
    </CardContainer>
  )
}
